import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {Map} from "immutable";
import {Icon, ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import solunionImage from "../../../assets/img/operacion-asegurada-ilunion-pequeno.png";

// Components
import SalesInvoiceDetail from "./SalesInvoiceDetail";
import SalesInvoiceFiles from './SalesInvoiceFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';
import SalesInvoicePrint from "../../../components/common/SalesInvoicePrint";

// Actions
import {
    getSalesInvoice,
    updateSalesInvoice,
    changeSalesInvoiceStatus,
    uploadSalesInvoiceFiles,
    downloadSalesInvoiceFile,
    deleteSalesInvoiceFile,
    deleteSalesInvoice,
    cleanSalesInvoices
} from "../../../actions/sales-invoices";
import {addNotification} from "../../../actions/notifications";
import {downloadPdf} from "../../../actions/content";

class SalesInvoiceTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getSalesInvoice(this.props.match.params.salesInvoiceId);
    }
    componentWillUnmount() {
        this.props.cleanSalesInvoices();
    }

    // Tab handlers
    getSelectedIndex() {
        const {salesInvoiceId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/ventas/facturas/' + salesInvoiceId + '/detalle':
                return 0;
            case '/ventas/facturas/' + salesInvoiceId + '/ficheros':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {salesInvoiceId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/ventas/facturas/' + salesInvoiceId + '/detalle';
                break;
            case 1:
                route = '/ventas/facturas/' + salesInvoiceId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // SalesInvoiceDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updateSalesInvoiceState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateSalesInvoice();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Print PDF
    printPdf = () => {
        const htmlHeader = ReactDOMServer.renderToStaticMarkup(<div></div>);
        const generateStaticMarkup = ReactDOMServer.renderToStaticMarkup(
            <SalesInvoicePrint
                salesInvoice={this.props.salesInvoice}
            />
        );
        const htmlFooter = ReactDOMServer.renderToStaticMarkup(
            <div style={{
                width: '100%',
                display: 'flex'
            }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: "100%" }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ fontSize: 10, marginBottom: 5, marginTop: 'auto' }}>
                            - <span className="pageNumber"></span> -
                        </div>
                        <div style={{ fontSize: 6 }} >INSCRITA EN EL REGISTRO MERCANTIL DE MURCIA, TOMO MU-3142, FOLIO 112, HOJA MU-87833</div>
                    </div>
                    <div style={{ marginLeft: 10, maxWidth: 100 }}>
                        <img src={solunionImage} style={{maxWidth: "100%"}} />
                    </div>
                </div>
            </div>
        );

        this.props.downloadPdf(generateStaticMarkup, {
            title: this.props.salesInvoice.get('invoice_code') + '.pdf',
            printBackground: true,
            displayHeaderFooter: true,
            headerTemplate: htmlHeader,
            footerTemplate: htmlFooter,
            margin: {
                top: '50px',
                right: '50px',
                left: '50px',
                bottom: '150px'
            }
        });
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar factura de venta',
                        body: (
                            <DeleteDialog
                                text={ this.props.salesInvoice.get('invoice_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteSalesInvoice(this.props.salesInvoice.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/ventas/facturas');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper binvoice-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/facturas">Facturas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.salesInvoice.get('invoice_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        <button
                                            className="btn btn-custom"
                                            onClick={ this.printPdf }
                                        ><Icon icon="print"/>Imprimir</button>
                                        { this.props.salesInvoice.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.salesInvoice.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <SalesInvoiceDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                salesInvoice={this.props.salesInvoice}
                                                updateSalesInvoice={this.props.updateSalesInvoice}
                                                changeSalesInvoiceStatus={this.props.changeSalesInvoiceStatus}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SalesInvoiceFiles
                                                salesInvoice={this.props.salesInvoice}
                                                uploadSalesInvoiceFiles={this.props.uploadSalesInvoiceFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadSalesInvoiceFile={this.props.downloadSalesInvoiceFile}
                                                deleteSalesInvoiceFile={this.props.deleteSalesInvoiceFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const salesInvoiceReducer = state.salesInvoices;

    // SalesInvoice
    let salesInvoice = salesInvoiceReducer.get('payload') || Map({});

    if (!(salesInvoice instanceof Map)) {
        salesInvoice = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: salesInvoiceReducer.get('isUploading') || false,
        percent: salesInvoiceReducer.get('percent') || 0
    });

    return {
        salesInvoice,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSalesInvoice: (salesInvoiceId) => dispatch(getSalesInvoice(salesInvoiceId)),
        updateSalesInvoice: (salesInvoiceId, salesInvoice) => dispatch(updateSalesInvoice(salesInvoiceId, salesInvoice)),
        changeSalesInvoiceStatus: (salesInvoiceId, status) => dispatch(changeSalesInvoiceStatus(salesInvoiceId, status)),
        uploadSalesInvoiceFiles: (salesInvoiceId, files) => dispatch(uploadSalesInvoiceFiles(salesInvoiceId, files)),
        downloadSalesInvoiceFile: (salesInvoiceId, fileId) => dispatch(downloadSalesInvoiceFile(salesInvoiceId, fileId)),
        deleteSalesInvoiceFile: (salesInvoiceId, fileId) => dispatch(deleteSalesInvoiceFile(salesInvoiceId, fileId)),
        deleteSalesInvoice: (salesInvoiceId) => dispatch(deleteSalesInvoice(salesInvoiceId)),
        cleanSalesInvoices: () => dispatch(cleanSalesInvoices()),
        addNotification: (notification) => dispatch(addNotification(notification)),
        downloadPdf: (htmlString, pdfOptions) => dispatch(downloadPdf(htmlString, pdfOptions))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesInvoiceTabs);



// WEBPACK FOOTER //
// ./src/containers/sales/invoices/SalesInvoiceTabs.js